export default __webpack_public_path__ + "static/media/Db_1.9365e204.png";